import { render, staticRenderFns } from "./ShopRegist.vue?vue&type=template&id=55a4de90&"
import script from "./ShopRegist.vue?vue&type=script&lang=js&"
export * from "./ShopRegist.vue?vue&type=script&lang=js&"
import style0 from "./ShopRegist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports